export enum VETTING_SOURCE {
	'MY_CARRIER_PACKETS' = 'MY_CARRIER_PACKETS',
	'RMIS' = 'RMIS',
	'HIGHWAY' = 'HIGHWAY',
	'C4' = 'C4',
}
